import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SellerProvider, useSeller } from '../context/SellerContext';

// Seller Pages
import SellerRegistrationLayout from '../components/seller/SellerRegistrationLayout';
import SellerDashboard from '../components/seller/SellerDashboard';
import SellerSettings from '../components/seller/SellerSettings';
import SellerLogin from '../components/seller/SellerLogin';
import SellerOrders from '../components/seller/SellerOrders';
import SellerReturns from '../components/seller/SellerReturns';
import SellerInventory from '../components/seller/SellerInventory';
import SellerPayments from '../components/seller/SellerPayments';
import SellerPricing from '../components/seller/SellerPricing';
import SellerClaims from '../components/seller/SellerClaims';
import SellerCatalogUpload from '../components/seller/SellerCatalogUpload';
import SellerImageUpload from '../components/seller/SellerImageUpload';
import SellerQuality from '../components/seller/SellerQuality';
import SellerWarehouse from '../components/seller/SellerWarehouse';
import SellerMarketing from '../components/seller/SellerMarketing';
import SellerNotices from '../components/seller/SellerNotices';
import SellerSupport from '../components/seller/SellerSupport';

import SellerLayout from '../components/seller/SellerLayout';

// Protected Route Component
const ProtectedSellerRoute = ({ children }) => {
  const { authToken } = useSeller();

  if (!authToken) {
    return <Navigate to="/seller/register" replace />;
  }

  return children;
};

const SellerRoutes = () => {
  return (
    <SellerProvider>
      <Routes>
        {/* Login */}
        <Route path="/login" element={<SellerLogin />} />

        {/* Registration Flow */}
        <Route path="/register" element={<SellerRegistrationLayout />} />

        {/* Protected Routes - Dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerDashboard />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Orders */}
        <Route
          path="/orders"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerOrders />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Returns */}
        <Route
          path="/returns"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerReturns />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Inventory */}
        <Route
          path="/inventory"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerInventory />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Payments */}
        <Route
          path="/payments"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerPayments />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Settings */}
        <Route
          path="/settings"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerSettings />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Pricing */}
        <Route
          path="/pricing/recommendation"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerPricing />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />
        <Route
          path="/pricing/calculator"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerPricing />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Claims */}
        <Route
          path="/claims"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerClaims />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Catalog Upload */}
        <Route
          path="/catalog-upload"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerCatalogUpload />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Image Bulk Upload */}
        <Route
          path="/image-upload"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerImageUpload />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Quality */}
        <Route
          path="/quality"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerQuality />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Warehouse */}
        <Route
          path="/warehouse"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerWarehouse />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Promotional Marketing */}
        <Route
          path="/influencer-marketing"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerMarketing />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Notices */}
        <Route
          path="/notices"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerNotices />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Support */}
        <Route
          path="/support"
          element={
            <ProtectedSellerRoute>
              <SellerLayout>
                <SellerSupport />
              </SellerLayout>
            </ProtectedSellerRoute>
          }
        />

        {/* Fallback */}
        <Route path="/*" element={<Navigate to="/seller/register" replace />} />
      </Routes>
    </SellerProvider>
  );
};

export default SellerRoutes;

